module.exports = __webpack_public_path__ + "img/6m.b1a1ca8a.jpg";